import BaseAuthenticationPopup from '@/global/BaseAuthenticationPopup.vue'
const authPopup = {
  authPopupData: {
    isShow: false,
    state: '',
    isLoading: false,
    isPersistent: false
  },
  close() {
    Object.assign(this.authPopupData, { isShow: false, isLoading: false })
  },
  show(state, isPersistent = false) {
    Object.assign(this.authPopupData, { isShow: true, state, isPersistent })
  },
  setLoading(val) {
    Object.assign(this.authPopupData, { isLoading: val })
  },
}

export default {
  install(Vue, pluginName = '$authPopup') {
    Vue.prototype[pluginName] = authPopup
    Vue.component('plugin-auth-popup', BaseAuthenticationPopup)
  }
}

export { authPopup }
